// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"180":"App","475":"views"}[chunkId] || chunkId) + "." + {"180":"2bc2788e","475":"81b5c7ab","990":"0f690c7a"}[chunkId] + ".chunk.css";
};